import { useStyles } from "../styles/loading-box.styles";
import { Box, CircularProgress } from "@material-ui/core";
import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function LoadingBox({ message = null }) {
  const classes = useStyles();
  const { t } = useTranslation();
  let displayMessage = "";
  if (message) {
    displayMessage = (
      <Typography className={classes.loadingTextMessage}>
        {t(message)}
      </Typography>
    );
  }
  return (
    <Box className={classes.loadingBox}>
      {displayMessage}
      <CircularProgress className={classes.loading} />
    </Box>
  );
}

export default LoadingBox;
